// Helpers för uppladdning av data-URL:er till Firebase Storage.
// Flyttad från App.tsx för att hålla komponentfilen smalare.
import { getDownloadURL, ref, type FirebaseStorage, uploadBytesResumable } from "firebase/storage";

export const MAX_IMAGE_SIZE = 10 * 1024 * 1024; // 10 MB

export async function uploadDataUrlWithProgress(
  dataUrl: string,
  storage: FirebaseStorage,
  storagePath: string,
  onProgress: (pct: number) => void
): Promise<string> {
  const blob = await (await fetch(dataUrl)).blob();
  if (blob.size > MAX_IMAGE_SIZE) {
    throw new Error("Bilden är för stor efter komprimering.");
  }
  const storageRef = ref(storage, storagePath);
  const task = uploadBytesResumable(storageRef, blob);

  return await new Promise<string>((resolve, reject) => {
    task.on(
      "state_changed",
      (snap) => {
        const pct = Math.round((snap.bytesTransferred / snap.totalBytes) * 100);
        onProgress(pct);
      },
      reject,
      async () => {
        const url = await getDownloadURL(task.snapshot.ref);
        resolve(url);
      }
    );
  });
}
